/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-12 15:40:50                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-25 16:02:48                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Services
  * DetailsDrawer: dissuspend details drawer
*/

/* Imports */
import { Button, Card, CardBody, CardFooter, Typography } from "@material-tailwind/react";
import { Modal } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { StopCircleIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { t } from "i18next";
/***/

/* Components */
import WorkordersStatusDisplay from "../../../../../components/data/workorder-status/WorkordersStatusDisplay";
import { WorkorderStatus } from "../../../../../types/workorder/workorderStatus";
/***/

/* Services */
import { api } from "../../../../../services/api/api";
/***/

import "./PlanningModal.scss";
import Loading from "../../../../../components/loading/Loading";

/**
* DetailsDrawer: dissuspend details drawer
* @param time - time to dissuspend
* @param onUpdate - on update callback, return updated time
*/
export default function SuspendWorkorderModal({
  open,
  workorder,
  onUpdate,
  onClose
}: {
  open: boolean,
  workorder: EasyTech.Workorder,
  onUpdate: (workorder: EasyTech.Workorder) => void
  onClose: () => void
}) {
  const [suspendLoad, setSuspendLoad] = useState<boolean>(false); 
  
  const changeStatus =(status: WorkorderStatus) => {
    setSuspendLoad(true);
    api.put(`users/workorders/${workorder.id}/status/${status}`, {})
      .then(() => {
        onUpdate({
          ...workorder,
          status: status
        });
        toast.success(t("workorder:logs:statusChanged"));
      }).catch((err) => {
        console.error("Erreur lors du changement de statut:", err);
        toast.error(t("workorder:status:changed_error"));
      }).finally(() => {
        setSuspendLoad(false);
        onClose();
      });
  };
  
  return(
    
    <Modal
      open={open}
      onClose={onClose}
      className="te-modal"
      aria-labelledby="te-modal"
      aria-describedby="te-modal">
      <Card className="te-modal-content  rounded-lg">
        <button className="close-button" onClick={() => onClose()}>
          <XMarkIcon className="w-4"/>
        </button>
        <CardBody>
          <div  className="flex items-center gap-3 mb-5">
            <div className="rounded-full border p-2 bg-light-green-200">
              <StopCircleIcon className="w-7 text-green-700" />
            </div>
            <Typography variant="h5">
              {t("admin:interventions:suspend:title", { ref: workorder.ref })}
            </Typography>
          </div>

          <Typography variant="paragraph">
            {t("admin:interventions:suspend:description")}
            <div className="inline-block px-2">
              <WorkordersStatusDisplay status={WorkorderStatus.SUSPENDED} />
            </div>
            .
          </Typography>
          <Typography variant="paragraph">
            {t("admin:interventions:technicianNotified")}
          </Typography>
          <Typography variant="paragraph">
            {t("admin:interventions:cancelDescription")}
            <div className="inline-block px-2">
              <WorkordersStatusDisplay status={WorkorderStatus.CANCELED} />
            </div>
            .
          </Typography>
        </CardBody>
        <CardFooter className="pt-0 flex gap-2 justify-end">
          <Button variant="outlined"
                  onClick={onClose}>
            {t("common:cancel")}
          </Button>

          {suspendLoad ?
            <Loading />
            :
            <>
              <Button color="blue"
                      onClick={() => changeStatus(WorkorderStatus.SUSPENDED)}>
                {t("admin:buttons:suspend")}
              </Button>

              <Button color="black"
                      onClick={() => changeStatus(WorkorderStatus.CANCELED)}>
                {t("common:cancel")}
              </Button>
            </>
          }
        </CardFooter>
      </Card>
    </Modal>
  );
}
/***/
